import React from 'react'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'

const FilterModal = observer(({ store }) => (
    <Modal
        show={store.filterModalOpen}
        onClose={store.handleCloseFilterModal}
    >
        <Typography>Add filter</Typography>
    </Modal>
))

export default FilterModal
